export const setBotHighlightedRow = (state, action) => {
  state.botHightlightedRow = action.payload
}
